import React from "react";
import MobileSidebar from "../Sidebar/MobileSidebar";
import BackgroundAnimated from "../BackgroundAnimated/BackgroundAnimated";
import { Outlet } from "react-router-dom";
import FooterMobile from "../Footer/FooterMobile";

function LayoutMobile() {
  return (
    <div className="layout h-full">
      <BackgroundAnimated />
      <MobileSidebar />

      <div className="main my-4">
        <Outlet />
      </div>

      <div className="footer w-full h-20 pt-6">
        <FooterMobile />
      </div>
    </div>
  );
}

export default LayoutMobile;
